module.exports = require("nprogress/nprogress.css");